<script lang="ts">
    import {
        Button, 
        ButtonSet, 
        Form, 
        PasswordInput, 
        TextInput, 
        ToastNotification} from "carbon-components-svelte";
    import {Credentials} from "../models/Credentials";
    import {Requests} from "../libreries/Requests";
    import ArrowRight20 from "carbon-icons-svelte/lib/ArrowRight20";
    import {logInOut} from "../stores";

    let credentials: Credentials = new Credentials();
    let requests: Requests = new Requests();
    $: isCorrect = true;

    async function login(){
        if(credentials.validate(credentials.username) && credentials.validate(credentials.password)){
            isCorrect = await requests.logIn(credentials);
            if(isCorrect){
                let me = await requests.getMe();
                logInOut.user.set({username: me.username, role: me.role});
            }
        }
    }
</script>
{#if !isCorrect}
<div>
    <ToastNotification title="Errore" subtitle="Username o password errati" style="position:absolute; right: 2rem;"/>
</div>
{/if}
<Form on:submit={login} class="login-container">
    <h2 class="margin-bottom-32">Log in</h2>
    <TextInput required type="text" bind:value={credentials.username} labelText="Username" />
    <PasswordInput required type="password" labelText="Password" bind:value={credentials.password} 
        hidePasswordLabel="Nascondi password" showPasswordLabel="Mostra password"/>
    <ButtonSet class="margin-top-16">
        <Button disabled kind="ghost" style="cursor: default"></Button>
        <Button  type="submit" icon={ArrowRight20}>Entra</Button>
    </ButtonSet>
</Form>